function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9609 7.54102C12.0879 7.41406 12.0879 7.21094 11.9609 7.10938L11.4531 6.60156C11.3516 6.47461 11.1484 6.47461 11.0215 6.60156L8.63477 9.06445V2.74219C8.63477 2.58984 8.50781 2.4375 8.33008 2.4375H7.61914C7.4668 2.4375 7.31445 2.58984 7.31445 2.74219V9.06445L4.95312 6.60156C4.82617 6.47461 4.62305 6.47461 4.52148 6.60156L4.01367 7.10938C3.88672 7.21094 3.88672 7.41406 4.01367 7.54102L7.77148 11.2988C7.89844 11.4258 8.07617 11.4258 8.20312 11.2988L11.9609 7.54102ZM12.5703 12.4922H3.42969C3.25195 12.4922 3.125 12.6445 3.125 12.7969V13.5078C3.125 13.6855 3.25195 13.8125 3.42969 13.8125H12.5703C12.7227 13.8125 12.875 13.6855 12.875 13.5078V12.7969C12.875 12.6445 12.7227 12.4922 12.5703 12.4922Z",
  fill: "#2B82F7"
});

var SvgIcnDownload16Px = function SvgIcnDownload16Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnDownload16Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-download-16px.b624725f.svg";
export { ForwardRef as ReactComponent };